// 模块引入
import Axios from 'axios'
import router from '../router'
import { Notification } from 'element-ui'

// 提示函数
const tip = mes => {
  Notification({
    message: mes,
    type: 'error',
    timeout: 2500
  })
}

// 跳转到登陆页
const toLogin = () => {
  // router.replace({
  //   path: '/login'
  // })
}

// 错误提示处理
const errorHandle = (status, other) => {
  console.log(111, status, other)
}

// 创建axios实例
const instance = Axios.create({
  baseURL: process.env.BASE_URL,        // 环境切换：通过配置参数自动切换
  timeout: 300000,                       // 设置请求超时时间：默认30秒
  withCredentials: true,                // 允许跨域
  // transformRequest: [(data)=>{          // 全局post请求格式转换
  //   return QS.stringify(data)
  // }]
})

// 配置POST请求的头信息
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

// 请求拦截
instance.interceptors.request.use(
  config => {
    return config
  },
  error => Promise.error(error)
)

// 响应拦截
instance.interceptors.response.use(
  // response => response.status == 200 ? Promise.resolve(response.data) : Promise.reject(response),
  response => {
    if(response.status == 200){
      if(response.data.code == 2){
        tip(response.data.msg)
        return setTimeout(()=>{toLogin()}, 1000)
      }
      return response.data.code ? tip(response.data.msg) : Promise.resolve(response.data)
    }else{
      return Promise.reject(response)
    }
  },
  error => {
    const { response } = error
    if(response){
      errorHandle(response.status, response.data.msg)
      return Promise.reject(error)
    }else{
      if(!window.navigator.onLine)
        store.commit('changeNetwork', false)
      else{
        errorHandle(400000, '网络请求错误')
        return Promise.reject(error)
      }
    }
  }
)

export default instance


// WEBPACK FOOTER //
// ./src/service/request.js